import { _ } from "../../core/polyglot/polyglot.js";
import AccountingDocument from "../shared/documentInfrastructure/AccountingDocument2/AccountingDocument.js";
import DrawerMenuWidget from "../../core/widgets/DrawerMenuWidget/DrawerMenuWidget.js";
import ForecastEditorDocumentContent from "./ForecastEditorDocumentContent/ForecastEditorDocumentContent.js";
import ForecastEditorDocumentCoordinator from "./ForecastEditorDocumentCoordinator.js";
import ForecastEditorDocumentService from "./ForecastEditorDocumentService.js";
import ForecastEditorDocumentState from "./ForecastEditorDocumentState.js";
import ForecastEditorTitleWidget from "./widgets/ForecastEditorTitleWidget/ForecastEditorTitleWidget.js";
import ForecastLoadingWidget from "../../core/widgets/ForecastLoadingWidget/ForecastLoadingWidget.js";
import session from "../../core/session.js";

/**
 * This function creates and returns a new forecast editor document and
 * everything that this document requires.
 */
export default function makeForecastEditorDocument() {
	const period = session.getCompany().lastActiveMonth();

	const coordinator = new ForecastEditorDocumentCoordinator({
		documentState: new ForecastEditorDocumentState({
			service: new ForecastEditorDocumentService({ session, period }),
			period,
		}),
		renderables: {
			content: new ForecastEditorDocumentContent({
				fiscalYears: session.getCompany().getYears(),
			}),
			title: new ForecastEditorTitleWidget({ period }),
			drawer: new DrawerMenuWidget(),
			periodPicker: false,
		},
	});

	return new AccountingDocument({
		coordinator,
		cssClass: "forecast-report forecast-editor",
		spinner: new ForecastLoadingWidget({
			title: _("Get ready to predict the future"),
			subtitle: _("Your forecast is loading…"),
		}),
	});
}
